// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';
import '../../styles/mobile.css';
import logo from '../../icon.png';
import logo2x from '../../icon@2x.png';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class MobileSplash extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		window.trackEvent( 'Pageview', {
			action: 'mobile-splash	'
		});
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		return <div className="mobile-container">

			<header><a href="./" className="logo"><img
				src={window.devicePixelRatio >= 2 ? logo2x : logo}/></a></header>

			<section className="top-fold">
				<div className="top-fold__message">
					<h1>Uh Oh</h1>

					<h2>Subtitle Studio uses technology currently not supported by your browser.</h2>

					<h2>Check out our main site to find out how Subtitle Studio can help you.</h2>

					<a href="http://subtitle.studio" className="btn btn_blue">Main Site</a>
				</div>
			</section>
		</div>
	}
}

export default MobileSplash;


// WEBPACK FOOTER //
// ./src/scenes/Mobile/mobile-splash.js